// extracted by mini-css-extract-plugin
export default {"lawyerDetailMaryiam":"LawyerDetailMaryiam_lawyerDetailMaryiam__qs7Y+"};